export const MOBILE_FOOTER_HORIZ_PADDING = 16;
export const TABLET_FOOTER_HORIZ_PADDING = 64;
export const DESKTOP_AND_ABOVE_FOOTER_HORIZ_PADDING = 96;
